import { render } from "./NotesDialog.vue?vue&type=template&id=1a52a888&scoped=true"
import script from "./NotesDialog.vue?vue&type=script&lang=js"
export * from "./NotesDialog.vue?vue&type=script&lang=js"

import "./NotesDialog.vue?vue&type=style&index=0&id=1a52a888&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a52a888"]])

export default __exports__